import React, { useEffect, useState } from 'react'
import Layout from '../components/Layout'
import { useDispatch, useSelector } from 'react-redux';
import { fetchCollectionData } from '../redux/slices/CollectionSlice';
import { IPFStoURL, formatPrice, getCurrentChain, trimAddress } from '../helper/functions';
import { Link, useNavigate } from 'react-router-dom';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { api } from '../helper/api';
import Countdowncomp from '../components/Countdowncomp';
import { CHAIN_INFO, DEFAULT_IMAGES } from '../helper/constant';
import { useAccount } from 'wagmi';


export default function Home() {
    //Owl Carousel Settings
    const collection_data = useSelector((state) => state.collection.collection_data);
    const [tradingNft, setTradingNft] = useState([]);
    const [listedNft, setListedNft] = useState([]);
    const [topUsers, setTopUsers] = useState([]);
    const [categories, setCategories] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { chainId } = useAccount();
    const currentChain = getCurrentChain(chainId);


    useEffect(() => {
        dispatch(fetchCollectionData());

    }, [dispatch]);


    useEffect(() => {
        async function fetch() {
            const response = await api.get('nft/trending', {
                params: {
                    limit: 8,
                }
            })

            if (response && response.data && response.data.error === 'OK') {
                setTradingNft(response.data.data);
            }
        }

        fetch();
    }, []);

    useEffect(() => {
        async function fetch() {
            const response = await api.get('nft/listed', {
                params: {
                    limit: 8,
                }
            })

            if (response && response.data && response.data.error === 'OK') {
                setListedNft(response.data.data);
            }
        }

        fetch();
    }, []);



    useEffect(() => {
        async function fetch() {
            const response = await api.get('nft/top-user', {
                params: {
                    limit: 10,
                }
            })

            if (response && response.data && response.data.error === 'OK') {
                setTopUsers(response.data.data);
            }
        }

        fetch();
    }, []);

    useEffect(() => {
        async function fetch() {
            const response = await api.get('collection/categories', {
                params: {
                    limit: 10,
                }
            })

            if (response && response.data && response.data.error === 'OK') {
                setCategories(response.data.data);
            }
        }

        fetch();
    }, []);

    const handleNavigation = (categoryId, categoryName) => {
        navigate('/collections', { state: { categoryId, categoryName } });
    };

    return (
        <Layout>
            <div class="no-bottom no-top" id="content">
                <div id="top"></div>
                <section id="section-hero" aria-label="section">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-6 offset-lg-3 text-center">
                                <div class="spacer-double"></div>
                                <h1>Discover, collect, and sell extraordinary <span class="text-gradient">NFTs</span></h1>
                                <p class="lead">
                                    BlockStar NFT is the world's largest NFT marketplace.</p>
                                <div class="spacer-10"></div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="pt-2 no-bottom">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div className='d-flex justify-content-between'>
                                    <h2>Latest Collections</h2>
                                    <Link to="/collections">
                                        More Collections <ArrowRightAltIcon />
                                    </Link>
                                </div>
                            </div>
                            {collection_data && collection_data.length > 0 ? (collection_data.map((items, key) => (
                                <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" key={key}>
                                    <div class="nft__item">
                                        <div class="nft__item_wrap">
                                            <Link to={`/collection/${items.nft_address}`}>
                                                <img src={items.profile ? IPFStoURL(items.profile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} class="nft__item_preview" alt="static" />
                                            </Link>
                                        </div>
                                        <div class="nft__item_info">
                                            <Link to={`/collection/${items.nft_address}`}>
                                                <h4>{items.name} ({items.symbol})</h4>
                                            </Link>
                                            {/* <div class="nft__item_click">
                                                <i class="fa fa-heart"></i><span>50</span>
                                            </div> */}
                                            <div className='d-flex justify-content-between mb-3'>
                                                <div class="nft__item_price">
                                                    <span>Floor Price : {items.floor_price ? formatPrice(items.floor_price / Math.pow(10, 18)) : '0'} BST</span>
                                                </div>
                                                <div class="nft__item_action">
                                                    <span>Volume : {items.volume ? formatPrice(items.volume / Math.pow(10, 18)) : '0'} BST</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                            )) : (
                                <div class="col-12 d-flex justify-content-center my-5">
                                    No Record Found
                                </div>
                            )}
                        </div>
                    </div>
                </section>
                <section id="section-collections" class="pt60 no-bottom">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2>Top Sellers in 30 days</h2>
                            </div>
                            <div class="col-md-12 wow fadeIn">
                                <ol class="author_list alt-2 d-col-3">
                                    {topUsers && topUsers.length > 0 ? (topUsers.map((items, key) => {
                                        return (
                                            <li key={key}>
                                                <div class="author_list_pp">
                                                    <a href="#sec">
                                                        <img class="lazy" src={items.user_profile ? IPFStoURL(items.user_profile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} alt="profile" />
                                                        <i class="fa fa-check"></i>
                                                    </a>
                                                </div>
                                                <div class="author_list_info">
                                                    <a href="#sec">{trimAddress(items.nftSeller)}</a>
                                                    <span>@{items.username ? items.username : '- -'}</span>
                                                </div>
                                                <div class="author_list_info_e">
                                                    <span>{items.total_value ? formatPrice(items.total_value / Math.pow(10, 18)) : 0} BST</span>

                                                </div>
                                            </li>
                                        )
                                    })) : (
                                        <div class="d-flex justify-content-center my-5">
                                            No Record Found
                                        </div>
                                    )}
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="pt60 no-bottom">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2>Trending NFTs</h2>
                            </div>
                            {tradingNft && tradingNft.length > 0 ? (tradingNft.map((items, key) => {
                                let metadata = items.metaData ? JSON.parse(items.metaData) : {};
                                let currencyInfo = CHAIN_INFO[currentChain].currency_support.filter((values) => items.ERC20Token && values.address.toLowerCase() === items.ERC20Token.toLowerCase())
                                items.currencyInfo = currencyInfo.length > 0 ? currencyInfo[0] : CHAIN_INFO[currentChain].currency_support[0];

                                return (
                                    <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" key={key}>
                                        <div class="nft__item">
                                            {items.saletype === "2" &&
                                                <Countdowncomp timestamp={items.auctionEnd} />
                                            }

                                            <div class="author_list_pp">
                                                <a href="#sec" data-bs-toggle="tooltip" data-bs-placement="top" title="Creator: Stacy Long">
                                                    <img class="lazy" src={items.user_profile ? IPFStoURL(items.user_profile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} alt="profile" />
                                                    <i class="fa fa-check"></i>
                                                </a>
                                            </div>
                                            <div class="nft__item_wrap">
                                                <Link to={`/${items.nft_address}/${items.tokenId}`}>
                                                    <img src={IPFStoURL(metadata?.['image'])} class="nft__item_preview" alt="static" />
                                                </Link>
                                            </div>
                                            <div class="nft__item_info p-2">
                                                <Link to={`/${items.nft_address}/${items.tokenId}`}>
                                                    <h4>{metadata.name ? metadata.name : `${items.col_name}`} #{items.tokenId}</h4>
                                                </Link>

                                                <div className='d-flex justify-content-between '>
                                                    <div class="nft__item_price">
                                                        <span>{items.nftHighestBid > 0 ? formatPrice(items.nftHighestBid / Math.pow(10, 18)) : formatPrice(items.price / Math.pow(10, 18))} {items.currencyInfo.symbol}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })) : (
                                <div class="col-12 d-flex justify-content-center my-5">
                                    No Record Found
                                </div>
                            )}

                        </div>
                    </div>
                </section>
                <section class="pt60 no-bottom">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2>Latest NFTs</h2>
                            </div>
                            {listedNft && listedNft.length > 0 ? (listedNft.map((items, key) => {
                                let metadata = items.metaData ? JSON.parse(items.metaData) : {};
                                let currencyInfo = CHAIN_INFO[currentChain].currency_support.filter((values) => items.ERC20Token && values.address.toLowerCase() === items.ERC20Token.toLowerCase())
                                items.currencyInfo = currencyInfo.length > 0 ? currencyInfo[0] : CHAIN_INFO[currentChain].currency_support[0];
                                return (
                                    <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12" key={key}>
                                        <div class="nft__item">
                                            {items.saletype === "2" &&
                                                <Countdowncomp timestamp={items.auctionEnd} />
                                            }

                                            <div class="author_list_pp">
                                                <a href="#sec" data-bs-toggle="tooltip" data-bs-placement="top" title="Creator: Stacy Long">
                                                    <img class="lazy" src={items.user_profile ? IPFStoURL(items.user_profile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)} alt="profile" />
                                                    <i class="fa fa-check"></i>
                                                </a>
                                            </div>
                                            <div class="nft__item_wrap">
                                                <Link to={`/${items.nft_address}/${items.tokenId}`}>
                                                    <img src={IPFStoURL(metadata?.['image'])} class="nft__item_preview" alt="static" />
                                                </Link>
                                            </div>
                                            <div class="nft__item_info p-2">
                                                <Link to={`/${items.nft_address}/${items.tokenId}`}>
                                                    <h4>{metadata.name ? metadata.name : `${items.col_name}`} #{items.tokenId}</h4>
                                                </Link>
                                                {/* <div class="nft__item_click">
                                                        <i class="fa fa-heart"></i><span>50</span>
                                                    </div> */}
                                                <div className='d-flex justify-content-between '>
                                                    <div class="nft__item_price">
                                                        <span>{items.nftHighestBid > 0 ? formatPrice(items.nftHighestBid / Math.pow(10, 18)) : formatPrice(items.price / Math.pow(10, 18))} {items.currencyInfo.symbol}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })) : (
                                <div class="col-12 d-flex justify-content-center my-5">
                                    No Record Found
                                </div>
                            )}

                        </div>
                    </div>
                </section>
                <section id="section-category" class="pt60 pb-5">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <h2>Popular Categories</h2>
                            </div>
                            {categories && categories.length > 0 && categories.map((items, index) => (
                                <div key={index} class="col-md-2 col-sm-4 col-12 mb-sm-30 my-2 wow fadeInRight" data-wow-delay=".1s">
                                    <a href='#sec' onClick={() => handleNavigation(items.id, items.name)} class="icon-box style-2 rounded">
                                        <i class={`${items.icon}`}></i>
                                        <span>{items.name}</span>
                                    </a>
                                </div>
                            ))}

                        </div>
                    </div>
                </section>
            </div >
        </Layout >
    )
}
